// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_vy","fallback":"e_wy","s40":"e_xy","s32":"e_yy"};